import React from 'react';
import ExperienceCard from "./ExperienceCard";
import { Jumbotron } from './migration';
import {
  Container,
  Row,
} from "react-bootstrap";

const Experience = ({ experiences }) => {
  return (
    <section className="section">
      {/* make outer container fluid and remove horizontal padding so the jumbotron
          can stretch full width. Jumbotron's inner containerClassName is set to
          container-fluid px-0 py-5 to remove its default fixed-width container */}
      <Container fluid className="px-0">
        <Jumbotron className="bg-white" containerClassName="container-fluid px-0 py-5">
          <h2 className="display-4 mb-5 text-center">
            {experiences.heading}
          </h2>
          <Row className="justify-content-center gx-5 gy-3">
            {
              experiences.data.map((data, index) => {
                return <ExperienceCard key={index} data={data} />
              })
            }
          </Row>
        </Jumbotron>
      </Container>
    </section>
  );
}

export default Experience;